module.exports = __webpack_public_path__ + "img/works_procurement_system_app_1.4806eb67.png";